import { lazy } from 'react';
// imports
import MainLayout from 'layout/MainLayout';
// import AuthGuard from 'utils/route-guard/AuthGuard';
// import ErrorBoundary from './ErrorBoundary';
import Loadable from 'ui-component/Loadable';
import { ProtectedRoute } from './ProtectedRoute';
import { UserRole } from 'Application/models';
import { ProtectedAgencyLocalTravelRoute } from './ProtectedAgencyLocalTravelRoute';

// travel
const GenerateQuoteKenya = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/GenerateQuote/index')));
const GenerateQuoteRwanda = Loadable(
    lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Rwanda/GenerateQuote/index'))
);

// const PendingQuote = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/PendingQuotes/index')));
const FailedQuote = Loadable(
    lazy(() =>
        import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/FailedQuotes/index').then((module) => ({
            default: module.AgencyUserGeneratedQuotes
        }))
    )
);
// const CanceledQuote = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/CanceledQuotes/index')));
const CompletedQuote = Loadable(
    lazy(() =>
        import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/CompletedTransactions/index').then((module) => ({
            default: module.AgencyUserCompletedTransactions
        }))
    )
);
// import AdminViewPolicy from 'Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/ViewPolicy';
const AdminViewPolicy = Loadable(
    lazy(() => import('Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/ViewPolicy'))
);
const RwandaAdminViewPolicy = Loadable(
    lazy(() => import('Application/pages/TravelPortal/Dashboard/Britam/Shared/CompletedTransactions/ViewPolicyRwanda'))
);

const ViewQuoteDetails = Loadable(
    lazy(() => import('Application/pages/TravelPortal/Dashboard/Britam/Shared/Quotes/ViewQuotation/ViewQuoteDetails'))
);

const Plans = Loadable(lazy(() => import('Application/pages/TravelPortal/Shared/travelplans/index')));
const Dashboard = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/Agency/Shared/statistics/index')));
// usermanagement
const Users = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/Agency/AgencyAdmin/Users/index')));

// support/settings
const Support = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Quotes/Kenya/GenerateQuote/index')));
// const Settings = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Settings').then(module => ({ default: module.Settings }))));
const Settings = Loadable(lazy(() => import('Application/pages/TravelPortal/Dashboard/shared/Settings/index')));

export const AgencyAdminRoutes = {
    path: '/agency',
    element: (
        <ProtectedRoute
            component={<MainLayout />}
            requiredRoles={[
                UserRole.ROLE_AGENCY_ADMIN,
                UserRole.ROLE_BRANCH_MANAGER,
                UserRole.ROLE_AGENT,
                UserRole.ROLE_UNDER_WRITER,
                UserRole.ROLE_REGIONAL_ADMIN
            ]}
        />
    ),
    children: [
        //TODO: Add agency admin routes
        {
            path: 'home',
            element: <Dashboard />
        },
        {
            path: 'travel-portal',
            children: [
                {
                    path: 'completed-transactions',
                    children: [
                        {
                            path: '',
                            element: <CompletedQuote />
                        },
                        {
                            path: 'viewpolicy',
                            element: <AdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy/:policyNumber', // Add :policyNumber to make it dynamic
                            element: <AdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy-kyc-rw',
                            element: <RwandaAdminViewPolicy />
                        },
                        {
                            path: 'viewpolicy-kyc-rw/:policyNumber', // Add :policyNumber to make it dynamic
                            element: <RwandaAdminViewPolicy />
                        }
                    ]
                },
                {
                    path: 'generated-quotes',
                    children: [
                        {
                            path: '',
                            element: <FailedQuote />
                        },
                        {
                            path: 'viewquotation/:quotationNumber',
                            element: <ViewQuoteDetails />
                        }
                    ]
                },
                {
                    path: 'generate-quote',
                    element: <GenerateQuoteKenya />
                },
                {
                    path: 'generate-quote-rw',
                    element: <GenerateQuoteRwanda />
                },
                {
                    path: 'travel-plans',
                    element: <Plans />
                }
            ]
        },
        {
            path: 'viewpolicy',
            element: <AdminViewPolicy />
        },
        {
            path: 'viewpolicy/:policyNumber', // Add :policyNumber to make it dynamic
            element: <AdminViewPolicy />
        },
        {
            path: 'viewpolicy-rw',
            element: <RwandaAdminViewPolicy />
        },
        {
            path: 'viewpolicy-rw/:policyNumber', // Add :policyNumber to make it dynamic
            element: <RwandaAdminViewPolicy />
        },
        // {
        //     path: '/home',
        //     element: <AgencyAdminHome />
        // },
        {
            path: 'local-travels',
            element: <ProtectedAgencyLocalTravelRoute />
        },
        {
            path: 'settings',
            element: <Settings />
        },

        {
            path: 'support',
            element: <Support />
        },
        {
            path: 'user-management',
            //* Wrap with protected route so an agency user does not access user management
            element: <ProtectedRoute component={<Users />} requiredRoles={[UserRole.ROLE_AGENCY_ADMIN]} />
            // errorElement: <ErrorBoundary />
        }
    ]
};
